<script>
    import Fullscreen from "svelte-fullscreen";
    import { Maximize } from 'lucide-svelte';
    import { Minimize } from 'lucide-svelte';
    import Button from "$lib/components/ui/button/button.svelte";
    import screenfull from 'screenfull';

    
</script>

<Fullscreen let:onRequest let:onExit let:onToggle>
    <slot {onToggle} />
    <div class="absolute bottom-7 right-5 flex gap-2">
        {#if screenfull.isFullscreen }
            <Button variant="default" on:click={() => onExit()}>
                <Minimize />
            </Button>
        {:else}
            <Button variant="secondary" on:click={() => onRequest()}>
                <Maximize />
            </Button>
        {/if}
    </div>
</Fullscreen>